/* eslint-disable @typescript-eslint/no-explicit-any */
import { Machine, assign } from 'xstate';
import {
  IDocs,
  IFinalResponse,
  ICommonResponse,
  MetadataTypes,
  IGenericResponseData,
} from '_core/types';
import { getReturnResponseDefault, prepareGenericData } from '_core/util';
import { sampleApi as API } from '../Apis';

import { SampleContext, SampleEvents, SampleStateSchema } from '../Types';

export const SampleDocs: IDocs = {
  title: 'DemostrationServiceMachine',
  description: '',
  version: '0.0.1',
  apis: [
    {
      name: API.definitions.API_DOMAIN,
      path: API.definitions.ENDPOINT_API_PATH,
      linkPostman: API.definitions.URL_POSTMAN,
      order: 1,
    },
  ],
  codeToExecute: 'Services.UtilsServices.demostrationServiceMachine',
};

const handlePrepareData = (ctx: SampleContext): IFinalResponse => {
  const contexts: (ICommonResponse | IFinalResponse | null)[] = Object.values(
    ctx,
  ).filter((c) => c);
  const keys = Object.keys(ctx);
  const metadata = {
    machineName: 'demostrationServiceMachine',
    machineVersion: SampleDocs.version,
  };

  const listOfDefs = [API.definitions];

  const genericData = prepareGenericData(contexts, keys, listOfDefs);

  const finalResponse = handleFinalResponse(genericData, metadata);

  return finalResponse;
};

const handleFinalResponse = (
  genericData: IGenericResponseData,
  metadata: MetadataTypes,
) => {
  const { errors, data, infos } = genericData;

  let finalReturn = getReturnResponseDefault(metadata);

  const hasNoErrors = errors?.length === 0;
  if (hasNoErrors) {
    finalReturn = {
      ...finalReturn,
      success: true,
      data,
    };
  } else {
    finalReturn = {
      ...finalReturn,
      success: false,
      errors: {
        flow: { smilesErrorService: true },
        infos,
        details: errors,
      },
    };
  }

  return finalReturn;
};

export const SampleMachine = Machine<
  SampleContext,
  SampleStateSchema,
  SampleEvents
>({
  id: 'GetSample',
  initial: 'IDLE',
  context: {
    endpointResponse: null,
    finalResponse: null,
  },
  states: {
    IDLE: {
      on: {
        START: 'INVOKE_API',
      },
    },
    INVOKE_API: {
      invoke: {
        id: 'getSample',
        src: (_, state) =>
          API.call.get({
            filter: state?.filter,
          }),
        onDone: {
          target: 'PREPARE_DATA',
          actions: assign({
            endpointResponse: (_, state) => state.data,
          }),
        },
        onError: {
          target: 'PREPARE_DATA',
          actions: assign({
            endpointResponse: (_, state) => state.data,
          }),
        },
      },
    },
    PREPARE_DATA: {
      id: 'prepareData',
      on: {
        '': {
          id: 'preparing',
          target: 'FINISH',
          actions: assign({
            finalResponse: (ctx) => handlePrepareData(ctx),
          }),
        },
      },
    },
    FINISH: {
      type: 'final',
    },
  },
});
